var _path, _path2, _rect, _path3, _path4, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaintingServiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 99,
    viewBox: "0 0 101 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9481 62.3377V38.961L100 35.0649V14.2857H3.89612",
    stroke: "#036235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1559 57.1429H59.7403V95.7013C59.7403 97.3582 58.3972 98.7013 56.7403 98.7013H47.1559C45.499 98.7013 44.1559 97.3581 44.1559 95.7013V57.1429Z",
    fill: "#09B162"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5.19479,
    width: 12.987,
    height: 18.1818,
    rx: 1,
    fill: "#09B162"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9871 50.6493V24.6753L42.8572 23.3766V49.3506C42.8572 50.2164 41.8182 51.948 37.6624 51.948C33.5065 51.948 31.6018 50.2164 31.1689 49.3506V40.2597H25.9741V50.6493C25.5412 51.948 23.6364 54.5454 19.4806 54.5454C15.3247 54.5454 13.42 51.948 12.9871 50.6493Z",
    fill: "#FFC200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4806 57.1429C24.3807 64.9351 31.2409 80.5195 19.4806 80.5195C7.7202 80.5195 14.5804 64.9351 19.4806 57.1429Z",
    fill: "#FFC200"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.79224,
    width: 85.7143,
    height: 28.5714,
    rx: 2,
    fill: "#9BDFBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintingServiceIcon);
export default __webpack_public_path__ + "static/media/painting_service_icon.6205e8850a420d05025f43e19e1de11d.svg";
export { ForwardRef as ReactComponent };